$(function () {
    $('.header-search__input').on('input', function () {
        let label = $(this).closest('label');
        let content = $(this).closest('.dropdown').find('.header-search__content');
        let wrapper = content.find('.header-search__wrapper');

        if ($(this).val().length < 3) {
            label.dropdown('hide');
            content.removeClass('show').addClass('d-none');
            wrapper.html("");
            return;
        }

        $.ajax({
            url: "/get-saunas/" + $(this).val(),
            dataType: "json",
            success: function (data) {
                if (data.view !== '') {
                    label.dropdown('show');
                    content.removeClass('d-none');
                    wrapper.html(data.view);
                } else {
                    label.dropdown('hide');
                    content.removeClass('show').addClass('d-none');
                }
            }
        });
    });
});
